import { getCourseConfig } from 'my-core/course-utils';
import { numberToCurrency } from 'my-utils';

import Label from 'my-elements/Label';

import Typography from '@mui/material/Typography';

const rootCss = ({ breakpoints, spacing }) => ({
  display: 'flex',
  alignItems: 'center',
  '& > * + *': { marginLeft: spacing(2) },

  '.OCPFCI-img': {
    width: 80,
    height: 80,
    borderRadius: 8,
  },
  '.OCPFCI-text': {
    flex: 1,
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      '& > * + *': { marginLeft: spacing(1) },
    },
  },

  [breakpoints.only('xs')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0,
      marginTop: spacing(1),
    },
  },
});

export default function OnlineCoursePurchaseFormCourseItem(props) {
  const { course, disablePrice, onlineCourse, total = null } = props;

  const { assessment_name, course_code, course_name, course_type, name, price, school_name } = onlineCourse;

  const subtitle = course_type === 'class_pass' ? `${course?.name || course_name} Textbook` : name;

  return (
    <div css={rootCss}>
      <img alt="course image" className="OCPFCI-img" src={getCourseConfig(course || onlineCourse).icon} />
      <div className="OCPFCI-text">
        <Typography
          sx={{
            color: 'text.secondary',
          }}
          variant="caption"
        >
          {course?.school_name || school_name}
        </Typography>
        <div>
          <Typography variant="h6">{course?.code || course_code}</Typography>
          {assessment_name && <Label color="secondary" label={assessment_name} />}
        </div>
        <Typography
          sx={{
            color: 'text.secondary',
          }}
          variant="body2"
        >
          {subtitle}
        </Typography>
      </div>
      {!disablePrice && (
        <Typography variant="h6">{total ? numberToCurrency(total) : numberToCurrency(price)}</Typography>
      )}
    </div>
  );
}
